export default __webpack_public_path__ + "static/media/ic_people.8a5afc2c.svg";